import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import {
  ContainerComponent,
  INavData,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective
} from '@coreui/angular-pro';

import { Subject, takeUntil } from 'rxjs';
import { DlModuleSelectorComponent } from '../../components/dl-module-selector/dl-module-selector.component';
import { GlobalDataService } from '../../services/global-data.service';
import { DefaultFooterComponent } from './default-footer/default-footer.component';
import { DynamicHeaderComponent } from './dynamic-header.component';
import { INavDataExtended } from '../../models/depart-region-depot.model';
@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    ContainerComponent,
    RouterOutlet,
    DynamicHeaderComponent,
    DefaultFooterComponent,
    DlModuleSelectorComponent
  ],
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultLayoutComponent {
  private navItems$ = new Subject<any>();
  public navItems: INavDataExtended[] = [];


  constructor(private global: GlobalDataService, private cdr: ChangeDetectorRef,
    private router: Router) {}

  ngOnInit() {
    this.global.getDepartmentData().pipe(
      takeUntil(this.navItems$)
    ).subscribe({
      next: (data) => {
        this.navItems = data;
 
        // 
        const firstDept = data.find(( item ) => item.type === 'DEPT');
        if (firstDept && this.router.url === '/') {
          this.router.navigate([firstDept.url], {state: {
              departmentName: firstDept.name
            }
          });
        }
       
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.navItems$.complete();
  }




}
